import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const Modal = ({ open, onOpenChange, title, children, wide, testid }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className={`${wide ? "max-w-3xl" : "max-w-lg"} max-h-[90vh] overflow-y-auto`} data-testid={testid}>
      <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
);

export const SaveBtn = ({ onClick, busy, children = "Simpan", testid = "modal-save-button" }) => (
  <button disabled={busy} onClick={onClick} data-testid={testid} className="h-10 px-5 rounded-md bg-emerald-600 text-white font-semibold hover:bg-emerald-700 disabled:opacity-50 w-full sm:w-auto">{children}</button>
);

export const NewBtn = ({ onClick, children, testid }) => (
  <button onClick={onClick} data-testid={testid} className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-emerald-700 transition-colors">+ {children}</button>
);
